import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { getReportOrders } from "../../../../actions/structure.action";
import { tableStructures } from "../../../../helpers/table-structures";
import CustomTable from "../../common/CustomTable";
import isEmpty from "../../../../utils/is-Empty";
import Select from "react-select";
import convertToLiters from "../../../../utils/convertToLiters";
import { CloseIcon } from "../../../../assets/svg/svg-icons";
import CustomModalWrap from "../../../common/CustomModalWrap";
import DashbordOrder from "../../common/DashbordOrder/indes";
import PageSpinner from "../../../common/PageSpinner";
import { exportOrdersToCSV } from "../../../../utils/exportOrdersToCSV";

const SalesReport = () => {
  const dispatch = useDispatch();
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [orders, setOrders] = useState([]);
  const [buyerOptions, setBuyerOptions] = useState([]);
  const [selectedBuyer, setSelectedBuyer] = useState(null);
  const [variantOptions, setVariantOptions] = useState([]);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [showOrderModal, setOrderModal] = useState(false);
  const [currentOrderId, setCurrentOrderId] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const storedFrom = localStorage.getItem("invoiceFromDate");
    const storedTo = localStorage.getItem("invoiceToDate");

    if (storedFrom && storedTo) {
      setFromDate(storedFrom);
      setToDate(storedTo);
    } else {
      const today = new Date();
      const priorDate = new Date();
      priorDate.setDate(today.getDate() - 30);
      const formatDate = (d) => d.toISOString().split("T")[0];
      setToDate(formatDate(today));
      setFromDate(formatDate(priorDate));
      localStorage.setItem("invoiceFromDate", formatDate(priorDate));
      localStorage.setItem("invoiceToDate", formatDate(today));
    }
  }, []);

  useEffect(() => {
    // Fetch invoices logic can be added here
    if (fromDate && toDate) {
      setLoading(true);
      getReportOrders(dispatch, fromDate, toDate).then((res) => {
        setLoading(false);
        setBuyerOptions([]);
        setSelectedBuyer(null);
        setVariantOptions([]);
        setSelectedVariant(null);
        if (!isEmpty(res) && res?.payload?.length > 0) {
          setOrders(res.payload);

          // Set the buyer filter dropdown
          const uniqueNames = [
            ...new Set(res.payload.map((u) => u.buyerInfo?.business_name).filter(Boolean)),
          ].sort((a, b) => a.localeCompare(b));
          setBuyerOptions(uniqueNames);

          // Set the variants filter dropdown
          const uniqueVariants = [
            ...new Set(
              res.payload.map((u) => u.product_variant_id?.[0]?.quantity).filter(Number.isFinite)
            ),
          ].sort((a, b) => a - b);
          setVariantOptions(uniqueVariants);
        } else {
          setOrders([]);
        }
      });
    }
  }, [dispatch, fromDate, toDate]);

  useEffect(() => {
    if (!isEmpty(orders) && orders?.length > 0) {
      let mFiltered = [...orders];

      if (!isEmpty(selectedBuyer)) {
        mFiltered = mFiltered.filter(
          (record) => record?.buyerInfo?.business_name === selectedBuyer
        );
      }

      if (!isEmpty(selectedVariant)) {
        mFiltered = mFiltered.filter(
          (record) => record?.product_variant_id?.[0]?.quantity === selectedVariant
        );
      }

      setFilteredData(mFiltered);
    } else {
      setFilteredData([]);
    }
  }, [orders, selectedBuyer, selectedVariant]);

  const orderViewToggle = () => setOrderModal(!showOrderModal);
  const OrderDetailsModal = () => {
    return (
      <CustomModalWrap
        className="modal-custom-class order-popup"
        hedaerContent={
          <>
            <h4>{"Order"}</h4>
            <p
              onClick={() => {
                orderViewToggle();
              }}
            >
              <CloseIcon />
            </p>
          </>
        }
        buttonClasses={"action-button  hidden"}
        buttonContant={"view"}
        isModalOpen={showOrderModal}
        showModal={orderViewToggle}
        closeModal={orderViewToggle}
      >
        <DashbordOrder
          id={currentOrderId}
          closeModal={orderViewToggle}
          isModalOpen={showOrderModal}
        />
      </CustomModalWrap>
    );
  };

  return (
    <>
      {loading && <PageSpinner />}
      {OrderDetailsModal()}
      <Container fluid className="seller-sales-report">
        <Form className="mb-3 mt-3">
          <Row className="align-items-center px-3">
            <Col xs={12} md={3} className="mb-2 mb-md-0">
              <h4 className="m-0">Sales Report</h4>
            </Col>
            {/* Filters (right on desktop, full width on mobile) */}
            {/* Right: Filters */}
            <Col xs={12} md={9} className="d-flex flex-row justify-content-end">
              {/* Inline label + input for From Date */}
              <div className="d-flex align-items-center ms-2">
                <Form.Label className="me-2 mb-0">From</Form.Label>
                <Form.Control
                  type="date"
                  value={fromDate}
                  onChange={(e) => {
                    setFromDate(e.target.value);
                    localStorage.setItem("invoiceFromDate", e.target.value);
                  }}
                  style={{ minWidth: "140px" }}
                />
              </div>
              <div className="d-flex align-items-center ms-2">
                <Form.Label className="me-2 mb-0">To</Form.Label>
                <Form.Control
                  type="date"
                  value={toDate}
                  onChange={(e) => {
                    setToDate(e.target.value);
                    localStorage.setItem("invoiceToDate", e.target.value);
                  }}
                  style={{ minWidth: "140px" }}
                />
              </div>
              <Select
                className="ms-2"
                options={buyerOptions.map((name) => ({
                  value: name,
                  label: name,
                }))}
                value={selectedBuyer ? { value: selectedBuyer, label: selectedBuyer } : null}
                onChange={(selected) => setSelectedBuyer(selected?.value || null)}
                placeholder="Select Buyer"
                isClearable
                isSearchable
                styles={{
                  placeholder: (base) => ({
                    ...base,
                    textAlign: "left", // <-- fix placeholder alignment
                  }),
                  singleValue: (base) => ({
                    ...base,
                    textAlign: "left", // <-- fix selected value alignment
                  }),
                  menu: (base) => ({
                    ...base,
                    textAlign: "left", // <-- fix dropdown alignment
                    zIndex: 999999,
                  }),
                  option: (base) => ({
                    ...base,
                    textAlign: "left", // <-- fix options alignment
                  }),
                }}
              />
              <Select
                className="ms-2"
                options={variantOptions.map((name) => ({
                  value: name,
                  label: convertToLiters(name),
                }))}
                value={
                  selectedVariant
                    ? { value: selectedVariant, label: convertToLiters(selectedVariant) }
                    : null
                }
                onChange={(selected) => setSelectedVariant(selected?.value || null)}
                placeholder="Select Variant"
                isClearable
                isSearchable
                styles={{
                  placeholder: (base) => ({
                    ...base,
                    textAlign: "left", // <-- fix placeholder alignment
                  }),
                  singleValue: (base) => ({
                    ...base,
                    textAlign: "left", // <-- fix selected value alignment
                  }),
                  menu: (base) => ({
                    ...base,
                    textAlign: "left", // <-- fix dropdown alignment
                    zIndex: 999999,
                  }),
                  option: (base) => ({
                    ...base,
                    textAlign: "left", // <-- fix options alignment
                  }),
                }}
              />
              <Button
                className="ms-2"
                onClick={() => exportOrdersToCSV(orders)}
                disabled={!orders.length}
              >
                <i class="bi bi-download"></i>
              </Button>
            </Col>
          </Row>
          <Row className="section-row mb-2 mt-2">
            <CustomTable
              enableRowActions
              data={filteredData}
              enableTopToolbar={false}
              enableBottomToolbar={true}
              enablePagination={true}
              enableFilters={false}
              emptyTableMsg={`No orders data found`}
              positionActionsColumn={"last"}
              columns={tableStructures.reports_orders}
              initialState={{
                columnPinning: {
                  right: ["mrt-row-actions"],
                },
              }}
              renderTopToolbarCustomActions={({ table }) => (
                <Row style={{ display: "flex", gap: "1rem", p: "0.5rem", flexWrap: "wrap" }}>
                  <h4>My Invoices</h4>
                </Row>
              )}
              renderRowActions={({ row, table }) => (
                <div className="table-action-box">
                  <Button
                    id={row.original.id}
                    onClick={() => {
                      setCurrentOrderId(row.original.id);
                      orderViewToggle();
                    }}
                  >
                    <i class="bi bi-eye"></i>
                  </Button>
                </div>
              )}
            />
          </Row>
        </Form>
      </Container>
    </>
  );
};

export default SalesReport;
